import { render, staticRenderFns } from "./TraceabilityDataTable.vue?vue&type=template&id=1395a2a7&scoped=true"
import script from "./TraceabilityDataTable.vue?vue&type=script&lang=js"
export * from "./TraceabilityDataTable.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityDataTable.vue?vue&type=style&index=0&id=1395a2a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1395a2a7",
  null
  
)

export default component.exports